import React from 'react';
import { Table as MuiTable, withStyles } from '@material-ui/core';

const style = (theme) => ({
});

const Table = React.forwardRef((props, ref) => <MuiTable {...props} ref={ref} />);
export default withStyles(style)(Table);
